import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  fieldError: {
    position: "absolute",
    bottom: -29,
  },
  wasteTypeField: {
    flex: 2,
    marginHorizontal: theme.spacing.xsmall2,
    zIndex: 1,
  },
  spinner: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: theme.spacing.xsmall,
  },
  postcodeMessage: {
    marginHorizontal: "auto",
  },

  skipsWrapper: createResponsiveStyles({
    base: {
      alignContent: "flex-start",
      flex: 3,
      marginHorizontal: theme.spacing.xsmall2,
      marginBottom: theme.spacing.medium,
    },
    large: {
      marginBottom: 0,
      alignItems: "flex-start",
    },
  }),
  panel: createResponsiveStyles({
    base: {
      marginBottom: theme.spacing.xlarge2,
      overflow: "visible",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      marginHorizontal: "auto",
    },
    large: {
      flexDirection: "row",
    },
  }),
  submitButtonContainer: {
    flex: 1,
    marginHorizontal: theme.spacing.xsmall2,
    alignItems: "center",
    justifyContent: "center",
  },
  submitButton: {
    marginTop: theme.spacing.medium,
    flexShrink: 0,
    fontFamily: "ProximaSemiBold",
  },
});
